import {
  Card,
  ConfigProvider,
  Divider,
  Layout,
  Skeleton,
  Space,
  Typography,
  theme,
  Flex,
  Image,
  Button,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { useParams } from "react-router-dom";
import companyService from "../../services/companyService";
import { useUserContext } from "../../contexts/UserContext";
import RadarChart from "../../components/charts/RadarChart";
import questionnaireService from "../../services/questionnaireService";
import BarChart from "../../components/charts/BarChart";
import ApexRadarChart from "../../components/charts/ApexRadar";
import { ReactComponent as IndustryIcon } from "../../assets/detail-pg-icons/industry-icon.svg";
import { ReactComponent as StrengthIcon } from "../../assets/detail-pg-icons/strength-icon.svg";
import { ReactComponent as Graph1 } from "../../assets/detail-pg-icons/domainVsMaturity.svg";
import { ReactComponent as Graph2 } from "../../assets/detail-pg-icons/graph2.svg";
import { ReactComponent as GenAI } from "../../assets/detail-pg-icons/Gen AI.svg";
import { ReactComponent as UnevaluatedIcon } from "../../assets/company-details-pg-icons/icon.svg";
import MaturityRadarChart from "../../components/charts/MaturityRadarChart";

const { Content } = Layout;

const Styles = {
  UnevaluatedContactDetails: {
    display: "flex",
    flexWrap: "wrap",
    // gap: "20px",
    justifyContent: "space-evenly",
    padding: "15px 25px 15px 25px",
    backgroundColor: "#D0E9F833",
    border: "1px, 0px, 0px, 0px solid #D0E9F833",
  },
};

const CompanyDetails = () => {
  const { companyId } = useParams();
  const { role } = useUserContext();
  const {
    token: { colorBgContainer, borderRadiusLG, colorPrimary },
  } = theme.useToken();

  const [companyData, setCompanyData] = useState({});
  const [companyLoading, setCompanyLoading] = useState(true);
  // const [dimensionsData, setDimensionsData] = useState([]);
  // const [domainsData, setDomainsData] = useState([]);

  const [scoresLoading, setScoresLoading] = useState(true);
  const [genai, setGenai] = useState({
    score: null,
    domainsData: null,
    dimensionsData: null,
  });
  const [selectedDomain, setSelectedDomain] = useState(null);

  const fetchData = (readinessIndexType, score, setState, callback) => {
    setScoresLoading(true);

    const dimensionsData = [],
      domainsData = [];

    questionnaireService
      .getDomains(readinessIndexType)
      .then((response) => {
        const domains = response?.data;

        questionnaireService
          .viewResponses(companyId, readinessIndexType)
          .then((response) => {
            const scores = response?.data;

            domains.forEach(({ id, title, dimensions }) => {
              const currentDomain = scores.find((item) => item.domainId === id);
              // console.log(currentDomain, id);
              domainsData.push({
                id,
                name: title,
                score: currentDomain.domainScore,
                maturity: currentDomain.maturityLevel,
              });
              dimensions.forEach(({ id: dimensionId, title }) => {
                const currentDimension = currentDomain.dimensionScores.find(
                  (item) => item.dimensionId === dimensionId,
                );
                dimensionsData.push({
                  name: title,
                  score: currentDimension?.dimensionScore,
                  maturity: currentDimension?.maturityLevel,
                  domainId: id,
                });
              });
            });

            setState({ score, dimensionsData, domainsData });

            callback(domainsData);

            console.log(dimensionsData);
            console.log(domainsData);
            // setDimensionsData(dimensionsData);
            // setDomainsData(domainsData);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => setScoresLoading(false));
      })
      .catch((error) => {
        console.log(error);
        setScoresLoading(false);
      });
  };

  useEffect(() => {
    setCompanyLoading(true);
    companyService
      .getCompanyById(companyId)
      .then((response) => {
        setCompanyData(response.data);
        console.log("working");
        const { overAllScore } = response.data;

        const genaiScore = overAllScore.find((obj) => obj.index === "genai");

        if (genaiScore)
          fetchData("genai", genaiScore, setGenai, (domainsData) => {
            console.log(domainsData[0]?.id);
            setSelectedDomain(domainsData[0]?.id);
          });
        else setScoresLoading(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setCompanyLoading(false));
  }, []);

  const handleSelectedDomainChange = (value) => {
    setSelectedDomain(value);
  };

  return (
    <div>
      <Layout style={{ minHeight: "100vh", minWidth: "1820px" }}>
        <Header bgColor={colorBgContainer} />
        <Content
          style={{
            padding: "0px 40px 0px 40px",
          }}
        >
          <div
            style={{
              // background: colorBgContainer,
              minHeight: 280,
              // padding: 36,
              borderRadius: 15,
              marginTop: 35,
              marginBottom: 35,
            }}
          >
            <Skeleton active={true} loading={scoresLoading}>
              <div
                className='main-div'
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "35px",
                }}
              >
                <div
                  className='top'
                  style={{
                    display: "flex",
                    gap: "35px",
                    width: "100%",
                    alignItems: "stretch",
                  }}
                >
                  {/* ------------top left starts------------------------------------------------------ */}
                  <div
                    style={{
                      display: "flex",
                      gap: "25px",
                      borderRadius: "10px",
                      padding: "20px",
                      boxShadow: "0px 8px 0px 0px #8051F4",
                      backgroundColor: "white",
                      width: "100%",
                      flex: 1,
                    }}
                  >
                    <div className='image'>
                      {companyData.companyImage ? (
                        <div
                          style={{
                            width: "299px",
                            height: "283px",
                            borderRadius: "20px",
                            border: "1px solid #D7E3F1",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Flex justify='center' align='center'>
                            <Image
                              src={companyData.companyImage}
                              style={{ height: "200px" }}
                            />
                          </Flex>
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "299px",
                            height: "283px",
                            backgroundColor: "rgb(200, 200, 200)",
                            borderRadius: "20px",
                            border: "1px solid #D7E3F1",
                          }}
                        ></div>
                      )}
                    </div>
                    <div
                      className='right-side-div'
                      style={{
                        display: "flex",
                        // alignItems: "end",
                        width: "100%",
                        // flexDirection: "column",
                        // gap: "10px",
                      }}
                    >
                      <Space
                        direction='vertical'
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography.Title
                          style={{
                            fontSize: "25px",
                            fontWeight: "700",
                            marginBottom: "24px",
                          }}
                        >
                          {companyData.companyName}
                        </Typography.Title>
                        <div
                          className='statistics'
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            gap: "50px",
                            width: "100%",
                            marginBottom: "35px",
                          }}
                        >
                          <Space>
                            <Flex justify='center' gap={8}>
                              <div>
                                <IndustryIcon />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "10px",
                                }}
                              >
                                <Typography.Text strong>
                                  Industry:
                                </Typography.Text>
                                <Typography.Text style={{ color: "#92A7BE" }}>
                                  {companyData.industry}
                                </Typography.Text>
                              </div>
                            </Flex>
                          </Space>
                          <Space>
                            <Flex justify='center' gap={8}>
                              <div>
                                <StrengthIcon />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "10px",
                                }}
                              >
                                <Typography.Text strong>
                                  Strength:
                                </Typography.Text>
                                <Typography.Text style={{ color: "#92A7BE" }}>
                                  {companyData.strength}
                                </Typography.Text>
                              </div>
                            </Flex>
                          </Space>
                        </div>

                        {/* <Divider style={{ margin: "5px 0" }} /> */}
                        <p
                          style={{
                            color: "#C0C0CF",
                            fontSize: "14px",
                            borderBottom: "1px dashed #C0C0CF",
                            marginBottom: "-10px",
                          }}
                        >
                          Basic Info
                        </p>

                        <div
                          className='contact-details'
                          style={{
                            display: "flex",
                            gap: "20px",
                            justifyContent: "space-between",
                            padding: "15px 25px 15px 25px",
                            backgroundColor: "#D0E9F833",
                            border: "1px, 0px, 0px, 0px solid #D0E9F833",
                            width: "100%",
                            flexWrap: "wrap",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography.Text strong>
                              Contact Person:
                            </Typography.Text>
                            <Typography.Text style={{ color: "#92A7BE" }}>
                              {companyData.personName}
                            </Typography.Text>
                          </div>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography.Text strong>
                              Designation:
                            </Typography.Text>
                            <Typography.Text style={{ color: "#92A7BE" }}>
                              {companyData.designation}
                            </Typography.Text>
                          </div>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography.Text strong>Email:</Typography.Text>
                            <Typography.Text style={{ color: "#92A7BE" }}>
                              {companyData.email}
                            </Typography.Text>
                          </div>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography.Text strong>
                              Contact No:
                            </Typography.Text>
                            <Typography.Text style={{ color: "#92A7BE" }}>
                              {companyData.contactNumber}
                            </Typography.Text>
                          </div>
                        </div>
                      </Space>
                      {/* </ConfigProvider> */}
                    </div>
                  </div>
                  {/* --------------------top left ends---------------------------- */}

                  {/* --------------------top right starts------------------ */}
                  {!scoresLoading && genai.score && (
                    <div
                      className='maturity-score'
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        width: 520,
                        fontWeight: "400",
                        height: "100%",
                      }}
                    >
                      <div
                        className='genAI'
                        style={{ display: "flex", height: "100%" }}
                      >
                        <div
                          className='genAI'
                          style={{
                            display: "flex",
                            gap: "25px",
                            backgroundColor: "white",
                            boxShadow: "0px 8px 0px 0px #8051F4",
                            borderRadius: "10px",
                            padding: "20px 25px 20px 25px",
                            width: "100%",
                            height: "100%",
                            alignItems: "center",
                          }}
                        >
                          <div
                            className='image'
                            style={{
                              width: "113px",
                              height: "103px",
                              border: "3px solid #8051F4",
                              borderRadius: "16px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <GenAI style={{ width: "54px", height: "56px" }} />
                          </div>
                          <div
                            className='maturity' /*style={{padding:'15px 25px 15px 25px'}}*/
                            style={{ width: "100%" }}
                          >
                            <p
                              style={{
                                margin: "0px",
                                // padding: "0px 28px 0px 28px",
                                color: "#C0C0CF",
                                fontSize: "14px",
                              }}
                            >
                              Score of GenAI
                            </p>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "12px",
                                backgroundColor: "#D0E9F833",
                                padding: "15px 25px 15px 25px",
                                // border:'2px solid black'
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "10px",
                                  // backgroundColor:'red'
                                }}
                              >
                                <Typography.Text
                                  strong
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "400",
                                  }}
                                >
                                  Maturity Score:
                                </Typography.Text>
                                <Typography.Text
                                  style={{ color: "#92A7BE", fontSize: "16px" }}
                                >
                                  {genai.score?.maturityLevel}
                                </Typography.Text>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "10px",
                                }}
                              >
                                <Typography.Text
                                  strong
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "400",
                                  }}
                                >
                                  Maturity:
                                </Typography.Text>
                                <Typography.Text style={{ color: "#92A7BE" }}>
                                  {genai.score?.maturity}
                                </Typography.Text>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* --------------------top right ends------------------- */}
                </div>

                {genai.score ? (
                  <div
                    className='bottom'
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "35px",
                      // borderRadius: "12px",
                      // backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div
                      className='bottom-right'
                      style={{
                        backgroundColor: "white",
                        width: "100%",
                        borderRadius: "12px",
                        padding: 25,
                      }}
                    >
                      <div className='heading'>
                        <p
                          style={{
                            fontSize: "25px",
                            fontWeight: "700",
                            color: "#07224D",
                          }}
                        >
                          Domain vs maturity:
                        </p>
                      </div>
                      <div
                        className='graph'
                        style={{
                          padding: "15px",
                          // border: "0.6px solid #C0C0CF",
                          borderRadius: "9px",
                        }}
                      >
                        <BarChart domainsData={genai.domainsData} />
                        {/* <Graph1 style={{width:"100%", height:"100%"}}/> */}
                      </div>
                    </div>
                    <div
                      className='bottom-left'
                      style={{
                        backgroundColor: "white",
                        width: "100%",
                        borderRadius: "12px",
                        padding: 25,
                      }}
                    >
                      <Flex
                        justify='space-between'
                        align='center'
                        className='heading'
                      >
                        <p
                          style={{
                            fontSize: "25px",
                            fontWeight: "700",
                            color: "#07224D",
                          }}
                        >
                          Dimensions vs Maturity:
                        </p>
                        {/* <div>
                          <Select
                            style={{ width: 279, height: 55 }}
                            value={selectedDomain}
                            onChange={handleSelectedDomainChange}
                            options={genai.domainsData.map(({ name, id }) => ({
                              value: id,
                              label: name,
                            }))}
                          />
                        </div> */}
                      </Flex>
                      <div
                        className='graph'
                        style={{
                          padding: "15px",
                          // border: "0.6px solid #C0C0CF",
                          borderRadius: "9px",
                        }}
                      >
                        {/* <Graph2 style={{width:"100%", height:"100%"}}/> */}
                        {/* <ApexRadarChart
                          dimensionsData={genai.dimensionsData.filter(
                            (obj) => obj.domainId == selectedDomain
                          )}
                        /> */}
                        <MaturityRadarChart
                          dimensionData={genai.dimensionsData}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <Flex
                    justify='flex-start'
                    vertical
                    align='center'
                    style={{ minHeight: "400px" }}
                  >
                    <div style={{ marginTop: 100 }}>
                      <UnevaluatedIcon />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "33.96px",
                          fontWeight: "700",
                          color: "#32324D",
                          margin: "0px",
                        }}
                      >
                        Company is not Evaluated
                      </p>
                      <p
                        style={{
                          fontSize: "24.45px",
                          fontWeight: "400",
                          color: "#666687",
                        }}
                      >
                        please fill the questionnaire
                      </p>
                    </div>
                  </Flex>
                )}
              </div>
            </Skeleton>
          </div>
        </Content>
        <Footer />
      </Layout>
    </div>
  );
};

export default CompanyDetails;
